/**
 * Форматирует Date в строку YYYY-MM-DD, используя локальные компоненты даты.
 *
 * ВАЖНО: Не используйте toISOString() для передачи дат на бэкенд!
 * toISOString() конвертирует в UTC, что может сдвинуть дату на день назад
 * для пользователей в положительных таймзонах (UTC+X).
 *
 * Пример проблемы с toISOString():
 * - Пользователь в Москве (UTC+3) создаёт дату: new Date(2026, 0, 31) // 31 января 00:00 MSK
 * - toISOString() возвращает: "2026-01-30T21:00:00.000Z" // 30 января в UTC!
 * - Бэкенд получает 30 января вместо 31-го
 *
 * @param date - объект Date
 * @returns строка в формате YYYY-MM-DD
 */
export function formatDateToYMD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export function parseUtcDate(input) {
    if (input === null || input === undefined || input === '')
        return null;
    // Defensive copy — Date is mutable, callers shouldn't be able to corrupt
    // values held by upstream owners through the returned reference.
    if (input instanceof Date) {
        return Number.isNaN(input.getTime()) ? null : new Date(input.getTime());
    }
    if (typeof input === 'number') {
        const d = new Date(input);
        return Number.isNaN(d.getTime()) ? null : d;
    }
    if (typeof input === 'object' && typeof input.toDate === 'function') {
        const d = input.toDate();
        return Number.isNaN(d.getTime()) ? null : d;
    }
    if (typeof input === 'string') {
        // Has explicit TZ: trailing Z, or ±HH:MM / ±HHMM after the time portion.
        // Only append `Z` to datetime-shaped strings (containing `T`); appending
        // it to a date-only string like "2026-04-26" produces an invalid input
        // in some engines.
        const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(input);
        const looksLikeDatetime = input.includes('T');
        const normalized = hasTimezone || !looksLikeDatetime ? input : `${input}Z`;
        const d = new Date(normalized);
        return Number.isNaN(d.getTime()) ? null : d;
    }
    return null;
}
